import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _map from 'lodash/map'
import Select from 'react-select'
import Button from './Button'
import FilterItemsField from './FilterItemsField'
import { constant } from 'lodash'

class Filters extends Component {
  constructor(props) {
    super(props)
    const selected = {}
    _map(props.filters, filter => {
      selected[filter.type] = {
        value: null,
        label: filter.label,
        isNotChecked: false,
      }
    })

    // Initialize with any existing filters from props
    const initialFilters = props.value || []
    
    // Update selected state based on initial filters
    initialFilters.forEach(filter => {
      if (selected[filter.type]) {
        selected[filter.type].value = filter.value
        selected[filter.type].itemId = filter.itemId || null
        selected[filter.type].isNotChecked = filter.isNot || false
      }
    })

    this.state = {
      currentFilter: initialFilters,
      selected,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ currentFilter: this.props.value || [] })
      
      // Also update selected state to reflect the current filters
      this.updateSelectedStateFromFilters(this.props.value || [])
    }
  }

  updateSelectedStateFromFilters = (filters) => {
    const { selected } = this.state
    
    // Reset all selected values first
    Object.keys(selected).forEach(type => {
      selected[type].value = null
      selected[type].itemId = null
      selected[type].isNotChecked = false
    })
    
    // Update selected state based on current filters
    filters.forEach(filter => {
      if (selected[filter.type]) {
        selected[filter.type].value = filter.value
        selected[filter.type].itemId = filter.itemId || null
        selected[filter.type].isNotChecked = filter.isNot || false
      }
    })
    
    this.setState({ selected })
  }

  handleChange = (type, val) => {
    const { selected } = this.state
    selected[type].value = (val && val.value) || null
    // Preserve optional item identifier for backend filtering when available
    selected[type].itemId = (val && (val.itemId || val.id)) || null
    this.setState({
      selected,
    })
  }

  onNotChecked = (type, checked) => {
    const { selected } = this.state
    selected[type].isNotChecked = checked
    this.setState({
      selected,
    })
  }

  onOperationClick = (type, isAnd) => {
    const { selected, currentFilter } = this.state
    currentFilter.push({
      isAnd,
      type,
      label: selected[type].label,
      value: selected[type].value,
      isNot: selected[type].isNotChecked,
      // Pass through optional item identifier for backend accuracy
      itemId: selected[type].itemId || null,
    })
    this.setState({
      currentFilter,
    })
    this.props.onFiltersChange(currentFilter)
  }

  onTagsChange = (tags, changed, changedIndexes) => {
    const { currentFilter } = this.state
    if (currentFilter.length > tags.length) {
      // remove filter
      currentFilter.splice(changedIndexes[0], 1)
      this.setState({ currentFilter })
      this.props.onFiltersChange(currentFilter)
    }
  }

  render() {
    const { filters, children, className } = this.props
    const { currentFilter, selected } = this.state

    const isInitial = currentFilter.length === 0
    const tags = _map(currentFilter, (filter, index) => {
      const item = {
        label: filter.label,
        value: filter.value,
        isNot: filter.isNot,
        isAnd: filter.isAnd,
      }
      // let item = ''
      // item += index !== 0 ? (filter.isAnd ? '(AND) ' : '(OR) ') : ''
      // item += `${filter.label} ${filter.isNot ? 'IS NOT' : 'IS'} '${filter.value}'`
      return item
    })

    return (
      <div className={`common-filters ${className || ''}`}>
        {tags.length > 0 && (
          <div className="f-output">
            <FilterItemsField
              value={tags}
              onChange={(tags, changed, changedIndexes) => this.onTagsChange(tags, changed, changedIndexes)}
              controlOutside
              placeholder={' '}
            />
          </div>
        )}
        <div className="f-body flex-align">
          {_map(filters, (filter, index) => (
            <div key={index} className="f-item">
              <div className="f-header">
                <div className="f-label">{filter.label}</div>
                <div className="f-checkbox">
                <label className="checkbox-description" htmlFor={`chkNegative_${index}`}>Not</label>

                  <div className="checkbox-group-square">
                    <div className="checkbox-square small">
                      <input
                        id={`chkNegative_${index}`}
                        type="checkbox"
                        disabled={!selected[filter.type].value}
                        checked={selected[filter.type].isNotChecked}
                        onChange={evt => this.onNotChecked(filter.type, evt.target.checked)}
                      />
                      <label htmlFor={`chkNegative_${index}`} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="f-dropdown">
                <Select
                  onChange={evt => this.handleChange(filter.type, evt)}
                  options={filter.options}
                  value={selected[filter.type].value}
                />
              </div>
              <div className="f-buttons">
                {isInitial && (
                  <Button
                    className="btn btn-primary"
                    type="button"
                    disabled={!selected[filter.type].value}
                    onClick={() => this.onOperationClick(filter.type, true)}
                  >
                    Add
                  </Button>
                )}
                {!isInitial && (
                  <Button
                    className="btn btn-primary"
                    type="button"
                    disabled={!selected[filter.type].value}
                    onClick={() => this.onOperationClick(filter.type, true)}
                  >
                    And
                  </Button>
                )}
                {!isInitial && (
                  <Button
                    className="btn btn-default"
                    type="button"
                    disabled={!selected[filter.type].value}
                    onClick={() => this.onOperationClick(filter.type, false)}
                  >
                    Or
                  </Button>
                )}
              </div>
            </div>
            ))}
        </div>
        {children}
      </div>
    )
  }
}

Filters.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  filters: PropTypes.array.isRequired, // [{label:string, type: string, options:[{label:string, value: string}]}]
}

Filters.defaultProps = {
  filters: [],
}

export default Filters
